export enum SectorErrors {
  DELETE = 'sectorss/deleteSector',
  CREATE = 'sectors/createSector',
  EDIT = 'sectors/editSector',
  GET = 'sectors/getSector'
}
